/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [simple-editable-box.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 28.02.19 13:23
 */

import React, {useState} from 'react';
import {RoundedButton} from "../navigation/buttons/nav-buttons";
import {NavigationGroup, NavigationRow} from "../navigation/layout/nav-layout";
import {useLanguage} from "../configuration/configuration";
import {AddAPhoto, Send} from "@material-ui/icons";
import {SoundcloudBrandIcon, VideoUploadIcon, YoutubeSquareIcon} from "../navigation/icons/nav-icons";

// editor supports text only in its edit box no Emoji
// TODO currently no options for visibility
const TextEditor = ({text, callback, mediaupload, youtube, videoUpload, soundcloud}) => {
    const [dialogText, setDialogText] = useState(text || '');
    const Lang = useLanguage();

    const handleEditorEnter = event => {
        event.preventDefault();
        callback(dialogText);
    };

    const handleChange = event => {
        setDialogText(event.target.value);
    };

    const hasNavigation = mediaupload || youtube || videoUpload || soundcloud ;
    return (
        <div className='text-editor' style={{border: '1px solid red'}}>
            {hasNavigation && <NavigationRow>
                <NavigationGroup/>

                <NavigationGroup className='mt-2'>
                    <RoundedButton className='ml-1' title={Lang.post.editor.uploadImageTooltip}
                                   onClick={mediaupload}>
                        <AddAPhoto aria-hidden="true"/>
                    </RoundedButton>

                    <RoundedButton className='ml-1' title={Lang.post.editor.uploadVideoTooltip} onClick={videoUpload}>
                        <VideoUploadIcon aria-hidden="true"/>
                    </RoundedButton>

                    <RoundedButton className='ml-1' title={Lang.post.editor.youTubeTooltip} onClick={youtube}>
                        <YoutubeSquareIcon aria-hidden="true"/>
                    </RoundedButton>

                    {/*<RoundedButton className='ml-1' title={Lang.post.editor.vimeoTooltip} onClick={vimeo}>*/}
                    {/*    <VimeoBrandIcon aria-hidden="true"/>*/}
                    {/*</RoundedButton>*/}

                    <RoundedButton className='ml-1' title={Lang.post.editor.soundcloudTooltip} onClick={soundcloud}>
                        <SoundcloudBrandIcon aria-hidden="true"/>
                    </RoundedButton>
                </NavigationGroup>
            </NavigationRow>}

            <NavigationRow>
            <textarea name="editablebox" className="text-editable-box-content text-editable-edit-mode"
                      placeholder={Lang.post.editor.placeholder}
                      value={dialogText}
                      onChange={handleChange}
                      required/>
            </NavigationRow>

            <NavigationRow className='mt-2'>
                <NavigationGroup/>
                <NavigationGroup >
                    <RoundedButton className='btn-primary ml-1' title={Lang.post.editor.saveTooltip}
                                   onClick={handleEditorEnter}>
                        <Send fontSize='small' aria-hidden="true" className='clr-white'/>
                    </RoundedButton>
                </NavigationGroup>
            </NavigationRow>
        </div>
    )
}

export default TextEditor;

